import { c as _c } from "react/compiler-runtime";
import { useProduct } from "@/queries/useProduct";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { getStarVariants, TrustpilotStar } from "./TrustpilotStar";
export default function TrustpilotProductReviews() {
  const $ = _c(21);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const averageRating = productAdmin?.ratingSummary?.starsAverage;
  const totalReviews = productAdmin?.ratingSummary?.numberOfReviews.total;
  if (!averageRating || !totalReviews) {
    return null;
  }
  let t0;
  let t1;
  let t2;
  if ($[0] !== averageRating || $[1] !== product.sku) {
    const displayStarVariants = getStarVariants(averageRating, 5);
    t2 = "flex mb-3 flex-col gap-1";
    t0 = "flex items-center gap-0.5 mb-1";
    let t3;
    if ($[5] !== product.sku) {
      t3 = (variant, index) => <TrustpilotStar key={`${product.sku}-star-${index}`} variant={variant} />;
      $[5] = product.sku;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t1 = displayStarVariants.map(t3);
    $[0] = averageRating;
    $[1] = product.sku;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t1) {
    t3 = <div className={t0}>{t1}</div>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== averageRating) {
    t4 = <span className="font-bold">{averageRating}</span>;
    $[10] = averageRating;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== totalReviews) {
    t5 = <a href="#reviews-section"><span className="font-bold">{totalReviews}</span> Trustpilot product reviews</a>;
    $[12] = totalReviews;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <div className="flex items-center gap-3 text-sm"><span className="text-foreground text-xs">Rated {t4} based on{" "}{t5}</span></div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}